// extracted by mini-css-extract-plugin
export default {"imageUploadStyles":"pure-image-upload_imageUploadStyles__ucGEh","uploadBtn":"pure-image-upload_uploadBtn__RO5hZ","required":"pure-image-upload_required__hDMJm"};